module.exports = __webpack_public_path__ + "static/media/danielle-roossien-at-buffing-machine.de8f381d.webp";